import { Link } from 'react-router';
import { useEmployeeCard } from '../api/employees';
import { Avatar } from '../components/Avatar';
import { Drawer } from '../components/Overlay';
import { ErrorState, LoadingState } from '../components/states';
import { usePersonDrawer } from './shellContext';

/** Публичная карточка сотрудника поверх любой страницы. */
export function EmployeeDrawer() {
  const { personId, open, close } = usePersonDrawer();
  const card = useEmployeeCard(personId);
  if (!personId) return null;

  if (!card.data) {
    return (
      <Drawer title="Сотрудник" onClose={close}>
        {card.isError ? (
          <ErrorState error={card.error} onRetry={() => void card.refetch()} />
        ) : (
          <LoadingState label="Загружаю карточку" />
        )}
      </Drawer>
    );
  }

  const person = card.data;
  return (
    <Drawer
      title={person.fullName}
      subtitle={person.position ?? 'Должность не указана'}
      header={<Avatar name={person.fullName} photoUrl={person.photoUrl} size="lg" />}
      onClose={close}
    >
      {person.status === 'dismissed' ? <p className="status status-bad">Уволен</p> : null}
      <section className="drawer-section">
        <h3 className="section-title">Где работает</h3>
        {person.departments.map((department) => (
          <Link key={department.id} to={`/org?department=${department.id}`} className="link">
            {department.name}
          </Link>
        ))}
        {person.city ? <span className="muted">{person.city}</span> : null}
      </section>

      <section className="drawer-section">
        <h3 className="section-title">{person.managers.length > 1 ? 'Руководители' : 'Руководитель'}</h3>
        {person.managers.length ? (
          <div className="member-list">
            {person.managers.map((manager) => (
              <button key={manager.id} type="button" className="member" onClick={() => open(manager.id)}>
                <Avatar name={manager.fullName} photoUrl={manager.photoUrl} size="md" />
                <span className="member-text">
                  <b>{manager.fullName}</b>
                  <small>{manager.position ?? ''}</small>
                </span>
              </button>
            ))}
          </div>
        ) : (
          <span className="muted">—</span>
        )}
      </section>

      {person.leads.length ? (
        <section className="drawer-section">
          <h3 className="section-title">Руководит</h3>
          {person.leads.map((lead) => (
            <div key={lead.id} style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
              <Link to={`/org?department=${lead.id}`} className="link">
                {lead.name}
              </Link>
              {lead.coHead ? <span className="chip chip-blue">соруководитель</span> : null}
            </div>
          ))}
          <span className="muted">Подчинённых напрямую: {person.directSubordinates}</span>
        </section>
      ) : null}

      {person.canOpenCabinet ? (
        <Link to={`/employees/${person.id}`} className="btn-primary" style={{ justifySelf: 'start' }}>
          Открыть кабинет
        </Link>
      ) : person.canReadKpi || person.canReadAttendance ? (
        <Link to={`/employees/${person.id}`} className="btn-primary" style={{ justifySelf: 'start' }}>
          KPI и посещения
        </Link>
      ) : null}
    </Drawer>
  );
}
